export default __webpack_public_path__ + "static/media/ico_minimize_graphic.e429e240.svg";